module.exports = {"540173400":"西藏文化旅游创意园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540173.json
// module id = 2685
// module chunks = 0